import { render } from "./Earth.vue?vue&type=template&id=8cac09a8"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Earth.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8cac09a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8cac09a8', __exports__)) {
    api.reload('8cac09a8', __exports__)
  }
  
  module.hot.accept("./Earth.vue?vue&type=template&id=8cac09a8", () => {
    api.rerender('8cac09a8', render)
  })

}


export default __exports__